import { getMuiTheme, getTheme } from '../utils/theme';

export const CURRENT_THEME_NAME = 'darkBlueTheme';
export const CURRENT_THEME = getTheme(CURRENT_THEME_NAME);
export const CURRENT_MUI_THEME = getMuiTheme('themeDefault');
